<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
         <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Fees Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <a :href="path" style="color:yellow;" target="blank">
                    Payment Policy!!!
                </a>
            </v-toolbar>
            <v-row justify="center">
                <v-tooltip top color="warning">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="red" outlined rounded small class="button" v-bind="attrs" v-on="on"
                            @click="dialog_issue = true"> Amount deducted but receipt not generated. click here</v-btn>
                    </template>
                    <span>
                        Steps to raise dispute.
                    </span>
                </v-tooltip>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_ay" item-value="ay_id"
                        :items="academic_year_list" item-text="academicyear" label="Academic Year" outlined
                        @click="show = false" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children"
                        label="Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle"
                        @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="1" md="1">
                    <v-btn class="button ma-0" :loading="data_loader" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row>
            
            <span v-if="show == true">
                <v-row justify="center">
                    AY :: {{current_ay}} <v-divider color="grey" class="mx-2" vertical></v-divider> Standard :: {{leaner_std}} <v-divider color="grey" class="mx-2" vertical></v-divider> Division :: {{leaner_div}} <br>
                 </v-row>   
                    <v-row justify="center" dense v-if="hasAnyDiscountApplicable">
                        <v-alert
                            type="info"
                            variant="tonal"
                            class="my-3 text-caption"
                            dense
                            >
                            <strong>Note:</strong> Discounts are applicable only on full payment.
                            If <strong>partial payment</strong> has been made, the discount will not be applied.
                        </v-alert>

                        <div style="background:#f5f7fa; padding:10px 14px;" v-if="org_id == 'vvp'">
                            <div style="font-size:14px;">
                                • Concession is applied on full fees except the Admission Fee. Admission Fee is not included in the concession calculation.<br/>
                                • प्रवेश शुल्क वगळता संपूर्ण शुल्कावर सवलत लागू केली जाते.
                            </div>
                        </div>
                    </v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table dense class="elevation-1 mytable">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>
                                            Name
                                        </th>
                                        <th>
                                            Total Amount
                                        </th>
                                        <th v-if="hasAnyDiscountApplicable">
                                            Discount Type
                                        </th>
                                        <th v-if="hasAnyDiscountApplicable">
                                            Discount Applied
                                        </th>
                                        <th v-if="hasAnyDiscountApplicable">
                                            Discount Date
                                        </th>
                                         <th v-if="hasAnyDiscountApplicable">
                                            Discount Amount
                                        </th>
                                        <th>
                                            Paid Amount
                                        </th>
                                        <th>
                                            Remaining Amount
                                        </th>
                                        <th v-if="org_id == 'wws' || org_id == 'vvp'">
                                            Late Fee Charge (If Applicable)
                                        </th>
                                        <th>
                                            Amount To Pay
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in installment_details_list" :key="index" class="text-center">
                                        <td><b>{{ item.name }}</b></td>
                                        <td>{{ item.fee }}</td>
                                        <td v-if="hasAnyDiscountApplicable">{{ item.discount_type ? item.discount_type : "--" }}</td>
                                        <td v-if="hasAnyDiscountApplicable">{{ item.discount_amount }}</td>
                                        <td v-if="hasAnyDiscountApplicable">{{ item.discount_date }}</td>
                                        <td v-if="hasAnyDiscountApplicable">{{ item.total_after_discount }}</td>
                                        <td>{{ item.paid_fee }}</td>
                                        <td>{{ item.balnace_fee }}</td>
                                        <td v-if="org_id == 'wws' || org_id == 'vvp'">{{ item.fine }} Rs. between {{
                                            item.due_date }}. <span
                                                v-if="item.due_date_variable_fine && item.variable_fine != 0"> Daily
                                                {{item.variable_fine}} Rs. after {{item.due_date_variable_fine}}</span>
                                        </td>
                                        <td v-if="item.balnace_fee > 0"><strong>{{ item.balnace_fee +
                                                item.fine_due_date}}</strong></td>
                                        <td v-else><strong>{{ item.balnace_fee}}</strong></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                
                <!-- <v-row justify="center">
                    <span v-for="(inst,index) in installment_list" :key="index">
                        <input type="hidden" :value="index + 1" />
                        <input type="radio" class="radiospace" v-model="inst_id" v-bind:value="inst"
                            @change="getmatrix(); getstatus(index,inst.name)" />
                        {{inst.name}}
                    </span>
                </v-row> -->
                <v-row
                    v-if="unpaidInstallments.length"
                    align="center"
                    justify="center"
                    class="mt-4"
                    >
                    <v-col
                        cols="12"
                        md="auto"
                        class="d-flex justify-center align-center flex-wrap"
                    >
                        <v-checkbox
                            v-for="(inst, index) in unpaidInstallments"
                            :key="inst.id"
                            v-if="isVisible(index)"
                            v-model="inst_id"
                            :label="inst.name"
                            :value="inst"
                            color="#0F2027"
                            class="mx-3"
                            @change="onToggle(inst, index)"
                        />
                    </v-col>
                    <v-col
                        cols="12"
                        md="2"
                        class="d-flex justify-center pt-0"
                    >
                        <v-btn
                        class="button ma-0"
                        
                        @click="getmatrix()"
                        >
                        Get Fee Details
                        </v-btn>
                    </v-col>
                </v-row>
                <!-- <v-row justify="center" class="my-3 radio-row">
                    <div
                        v-for="(inst, index) in installment_list"
                        :key="index"
                        class="radio-item"
                    >
                        <input
                        type="radio"
                        class="radiospace"
                        v-model="inst_id"
                        :value="inst"
                        @change="getmatrix(); getstatus(index, inst.name)"
                        />
                        <span>{{ inst.name }}</span>
                    </div>
                </v-row> -->


                <v-row v-if="matrix_list.length > 0">
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table dense class="elevation-1 mytable">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>
                                            Fees Component
                                        </th>
                                        <th>
                                            Total Amount
                                        </th>
                                        <th>
                                            Paid Amount
                                        </th>
                                        <th>
                                            Remaining Amount
                                        </th>
                                        <th>
                                            Amount To Pay
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="text-center">
                                    <tr v-for="item in matrix_list" :key="item.lid">
                                        <td>{{ item.feescomponentacademicyear }}</td>
                                        <td>{{ item.amount }}</td>
                                        <td>{{ item.paid_till_now }}</td>
                                        <td>{{ item.reamining }}</td>
                                        <td>{{ item.amount_pay }}</td>
                                    </tr>
                                    <tr class="toolbar noborder">
                                        <td class="noborder toolbar"></td>
                                        <td class="noborder toolbar"></td>
                                        <td class="noborder toolbar"></td>
                                        <td class="noborder toolbar"><span v-if="total_amount != 0">Late Fee Charge ::
                                                {{fine}} </span></td>
                                        <td class="noborder toolbar">Total Amount To Pay :: {{total_amount}}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                
                <!-- <v-row v-if="matrix_list!=''" justify="center">
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color1">Total Fees :: {{fees_amount}}</span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color3">Discount Amount :: {{discount_value}} <span v-if="discount_type == 'Percentage'">%</span></span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color2">Paid Fees :: {{paid_amount}}</span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="total_amount != 0">
                        <span class="text-color">Late Fee Charge :: {{fine}}</span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color">Remaining Fees :: {{total_amount}}</span>
                    </v-col>
                </v-row> -->
                <v-row
                    v-if="matrix_list.length > 0"
                    justify="center"
                    align="center"
                    class="fee-summary-row"
                    >
                    <v-col cols="12" sm="auto" class="fee-item total">
                        
                        <span>Total Fees :: {{ fees_amount }}</span>
                    </v-col>

                    <v-col cols="12" sm="auto" class="fee-item discount" v-if="discount_value">                        
                        <span> Discount :: {{ discount_value }}<span v-if="discount_type === 'Percentage'">%</span>  </span>
                                              
                    </v-col>

                    <v-col cols="12" sm="auto" class="fee-item paid">                         
                        <span>Paid Fees :: {{ paid_amount }}</span>
                    </v-col>

                    <v-col
                        cols="12"
                        sm="auto"
                        class="fee-item fine"
                        v-if="total_amount != 0"
                    >                        
                        <span>Late Fee :: {{ fine }}</span>
                    </v-col>

                    <v-col cols="12" sm="auto" class="fee-item remaining">                        
                        <span>Remaining :: {{ total_amount }}</span>
                    </v-col>
                </v-row>

                <span class="flash" v-if="matrix_list.length > 0 && total_amount!=0"><strong>
                        <center>Please do not REFRESH or CLOSE ERP page at the time of transaction</center>
                    </strong></span>
                <v-row justify="center" class="my-2" v-if="matrix_list.length > 0">
                    <form :action="url" v-if="pg_hidden!=null && pgs.includes('PayTM')" @submit="payment"
                        name="paytmform" method="POST">
                        <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                        <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                        <input type="hidden" :value="pg_hidden.uid" name="uid" />
                        <input type="hidden" :value="pg_hidden.studid" name="studid" />
                        <input type="hidden" :value="pg_hidden.ay" name="ay" />
                        <input type="hidden" :value="total_amount" name="fee_amount" />
                        <input type="hidden" :value="inst_id.name" name="purpose" />
                        <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                        <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                        <v-btn class="button" :loading="pg_loader" v-if="total_amount!=0" type="submit">Pay Online
                            [PayTM]</v-btn>
                    </form>
                    <form :action="billdesk_url" v-if="pg_hidden != null && pgs.includes('Bill-Desk')" @submit="payment"
                        name="paytmform" method="POST">
                        <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                        <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                        <input type="hidden" :value="pg_hidden.uid" name="uid" />
                        <input type="hidden" :value="pg_hidden.studid" name="studid" />
                        <input type="hidden" :value="pg_hidden.ay" name="ay" />
                        <input type="hidden" :value="total_amount" name="fee_amount" />
                        <input type="hidden" :value="inst_id.name" name="purpose" />
                        <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                        <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                        <v-btn class="button" :loading="pg_loader" v-if="total_amount != 0" type="submit">Pay Online
                            [Bill-Desk]</v-btn>
                    </form>
                    <form :action="easebuzz_url" v-if="pg_hidden != null && pgs.includes('EaseBuzz')" @submit="payment"
                        name="paytmform" method="POST">
                        <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                        <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                        <input type="hidden" :value="pg_hidden.uid" name="uid" />
                        <input type="hidden" :value="pg_hidden.studid" name="studid" />
                        <input type="hidden" :value="pg_hidden.ay" name="ay" />
                        <input type="hidden" :value="total_amount" name="fee_amount" />
                        <input type="hidden" :value="inst_id.name" name="purpose" />
                        <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                        <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                        <v-btn class="button" :loading="pg_loader" v-if="total_amount != 0" type="submit">Pay Online
                            [EaseBuzz]</v-btn>
                    </form>
                    <form :action="razorpay_url" v-if="pg_hidden != null && pgs.includes('RAZORPAY')" @submit="payment"
                        name="paytmform" method="POST">
                        <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                        <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                        <input type="hidden" :value="pg_hidden.uid" name="uid" />
                        <input type="hidden" :value="pg_hidden.studid" name="studid" />
                        <input type="hidden" :value="pg_hidden.ay" name="ay" />
                        <input type="hidden" :value="total_amount" name="fee_amount" />
                        <input type="hidden" :value="inst_id.name" name="purpose" />
                        <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                        <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                        <input type="hidden" value="INSTALLMENT" name="payment_type" />
                        <v-btn class="button" :loading="pg_loader" v-if="total_amount != 0" type="submit">Pay Online
                            [RAZORPAY]</v-btn>
                    </form>
                    <v-btn class="button" v-if="pg_hidden != null && pgs.includes('BILLDESKJWSWHMAC')" @click="payBillDesk(pg_hidden.orgid,
                      pg_hidden.tenantid,pg_hidden.uid,pg_hidden.studid,pg_hidden.ay,total_amount,inst_id.name,matrix_pg_list,pg_hidden.hash_val)">
                        Pay Online[BILLDESK]
                    </v-btn>
                      <v-btn v-if="pg_hidden != null && pgs.includes('GRAYQUEST')" class="button"
                      apply_loan(pg_hidden.orgid,pg_hidden.ay,pg_hidden.tenantid,pg_hidden.uid,pg_hidden.studid,total_amount,pg_hidden.hash_val,matrix_pg_list)
                      @click="apply_loan(pg_hidden.orgid,pg_hidden.ay,pg_hidden.tenantid,pg_hidden.uid,pg_hidden.studid,total_amount,pg_hidden.hash_val,matrix_pg_list)">
                        Pay Online[GRAYQUEST]
                    </v-btn>
                    <span v-if="this.billdeskhmac">
                         {{billdeskhmacData}}
                        <center>
                            <form method="POST" :action="billdeskhmacData.href">
                                <input type="hidden" name="bdorderid" id="bdorderid" :value="billdeskhmacData.bdorderid" />
                                <input type="hidden" name="merchantid" id="merchantid" :value="billdeskhmacData.mercid" />
                                <input type="hidden" name="rdata" id="rdata" :value="billdeskhmacData.rdata" />
                                <v-btn style="margin: 2px; width: 200px;" type="submit" name="button" color="primary" class="mb-2 button">Pay By Billdesk</v-btn>
                            </form>
                        </center>
                    </span>
                    <v-btn  class="button" v-if="pg_hidden != null && pgs.includes('CCAVENUE')" :loading="btnloader" @click="payWithCCAvenue()">
                        Pay Online[CCAVENUE]
                    </v-btn>
                    <v-btn  class="button" v-if="pg_hidden != null && pgs.includes('PayU')" :loading="btnloader" @click="payWithPayU()">
                        Pay Online[PayU]
                    </v-btn>
                    <v-form v-if="ccUrl" :action="ccUrl" method="POST" name="ccavenueform">
                        <input type="hidden" name="encRequest" :value="encRequest" />
                        <input type="hidden" name="access_code" :value="accessCode" />
                    </v-form>

                    <form v-if="pu_url"
                        ref="payuForm"
                        :action="pu_url"
                        method="post"
                    >
                        <input type="hidden" name="firstname" :value="payu_data.firstname" />
                        <input type="hidden" name="lastname" :value="payu_data.lastname" />
                        <input type="hidden" name="surl" :value="payu_data.surl" />
                        <input type="hidden" name="phone" :value="payu_data.phone" />
                        <input type="hidden" name="key" :value="payu_data.key" />
                        <input type="hidden" name="hash" :value="payu_data.hash" />
                        <input type="hidden" name="curl" :value="payu_data.curl" />
                        <input type="hidden" name="furl" :value="payu_data.furl" />
                        <input type="hidden" name="txnid" :value="payu_data.txnid" />
                        <input type="hidden" name="productinfo" :value="payu_data.productinfo" />
                        <input type="hidden" name="udf1" :value="payu_data.udf1" />
                        <input type="hidden" name="udf2" :value="payu_data.udf2" />
                        <input type="hidden" name="udf3" :value="payu_data.udf3" />
                        <input type="hidden" name="udf4" :value="payu_data.udf4" />
                        <input type="hidden" name="udf5" :value="payu_data.udf5" />
                        <input type="hidden" name="drop_category" value="EMI" />
                        <input type="hidden" name="amount" :value="payu_data.amount" />
                        <input type="hidden" name="email" :value="payu_data.email" />
                    </form>
                </v-row>

                <span v-if="matrix_list.length > 0 && total_amount!=0"><strong>
                        <center>Standard charges will apply, based on Mode of Payment</center>
                    </strong></span>

            </span>
        </v-card>
        <v-dialog v-model="dialog_outsatnding" fullscreen>
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Student Otstanding Fees
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_outsatnding=false"><v-icon> mdi-close
                        </v-icon></v-btn>
                </v-toolbar>
                <student-outstanding-fees :selected_children="selected_children"></student-outstanding-fees>
                <v-row justify="center">
                    <v-btn class="button no-display" @click="dialog_outsatnding=false">Cancel</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_issue" persistent max-width="1500px">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Raise Dispute
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_issue=false"><v-icon> mdi-close
                        </v-icon></v-btn>
                </v-toolbar>
                <v-col cols="12" sm="12" md="`12">
                    <center>
                        You can raise dispute, if amount is deducted from your bank, but receipt is not generated. <br>
                        Click on "Proceed", which will redirect to Payment History Page where you can raise dispute for
                        that transaction. <br>
                        Refer below figure for the same.
                        <img :src="history" width="100%" height="100%" alt="logo" />
                    </center>
                </v-col>
                <v-row justify="center">
                    <v-btn class="button">
                        <router-link style="text-decoration: none;color:black" :to="{name: 'parent-fee-history' }"
                            class="root">
                            Proceed
                        </router-link>
                    </v-btn>
                    <v-btn class="button no-display" @click="dialog_issue=false">Cancel</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
         <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Online Fee Payment Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/tQDQSV7odig?si=tW-3ZJl4x5gCokDo"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
import StudentOutstandingFees from "../Parent/StudentOutstandingFees";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
         name: "StudentOutstandingFees",
        components: {
            "student-outstanding-fees": StudentOutstandingFees,
            Breadcrumbs
        },
        data: () => ({
            child_info: null,
            children: [],
            selected_install: [],
            videoDialog:false,
            get_component_installmet_list: [],
            show: false,
            dialog_outsatnding:false,
            dialog_issue:false,
            selected_children: null,
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            data_loader: false,
            btnloader: false,
            current_ay: "",
            search: "",
            s3url: "",
            leaner_std: null,
            leaner_div: null,
            installment_list: [],
            inst_id: [],
            matrix_list: "",
            total_amount: "",
            paid_amount: "",
            fees_amount: "",
            discount_value: "",
            discount_type: "",
            total_after_discount: "",
            debit_card_charges: "",
            credit_card_charges: "",
            netbanking_card_charges: "",
            fine: "",
            display_flag: false,
            matrix_pg_list:null,
            pg_hidden:null,
            pg_loader:false,
            path:null,
            total_outstanding:null,
            paid_outstanding:null,
            remaining_outstanding:null,
            outstanding:null,
            installment_details_list:[],
            outstanding_details_list:[],
            academic_year_list:[],
            selected_ay:null,
            razorpay_url:null,
            //added 18-04-22
            learner_info:null,
            ay_header:null,
            all_total_amount:null,
            all_total_paid:null,
            history:null,
            all_total_remaining:null,
            //
            pgs:[],
            billdesk: false,
            billdeskhmac: false,
            billdeskhmacData: [],
            org_id:null,
            encRequest: null,
            accessCode: null,
            ccUrl: null,
            ccInitiateUrl: null,
            payuInitiateUrl:null,
            pu_url:null,
            returnURL:null,
            payu_data:null
        }),
        created(){
        // this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm"
         this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm"
         this.billdesk_url=process.env.VUE_APP_BD_URL + "/paymentGatewayBillDesk/billdesk"
         this.easebuzz_url=process.env.VUE_APP_API_URL + "/PaymentGatewayEaseBuzz/easebuzz"
         this.razorpay_url=process.env.VUE_APP_API_URL + "/PayementGatewayzRazorPay/razorPayInitiate"
        //  this.billdesk_url="https://schoolerpbilldesk.edupluscampus.com/paymentGatewayBillDesk/billdesk"
        this.ccInitiateUrl = process.env.VUE_APP_API_URL + "/paymentGatewayCCAvenue/initiateInvoiceCCAvenuePayment";
        this.payuInitiateUrl = process.env.VUE_APP_API_URL + "/PayementGatewayPayU/initaitePayUPayment";
    },
        computed: {
            hasAnyDiscountApplicable () {
                return this.installment_details_list.some(
                item => item.is_discount_applicable === true
                )
            },
            unpaidInstallments() {
                return this.installment_details_list
                .filter(i => i.balnace_fee > 0)
                .sort((a, b) => a.id - b.id); // or by due_date if needed
            },
        },
        methods: {


            async apply_loan(org,academicyear_id,tenantid,uid,stud_id,fee_amount,hash_val,json_pre_trans_data){
                const data ={
                    ay:academicyear_id,
                    orgid:org,
                    studid:stud_id,
                    uid:uid,
                    fee_amount:fee_amount,
                    tenantid:tenantid,
                    hash_val:hash_val,
                    json_pre_trans_data:json_pre_trans_data
                }
                this.initiateFeesPaymentLoader = true;
                axios
                  .post("/payementGatewayzGrayQuest/grayQuestIntiatePayment", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                        console.log("res.data.gray_url:::::"+res.data.gray_url)
                        this.loadGQERPSDK(res.data.gray_url);
                              setTimeout(function () {
                                  //your code here
                              }, 3000);
                              this.initializeGqErpSDK(res.data.referenceNumber,
                               res.data.totalFeesDue,
                               res.data.gray_clientId, res.data.gray_client_secret, 
                               res.data.gray_api_key, res.data.online_payment_account_no,
                               res.data.org_logo,tenantid,res.data.order_id,fee_amount);
                      } else if (res.data.flag == "NO"){
                          this.showSnackbar("#b71c1c", res.data.fsmg);
                      }
                      this.initiateFeesPaymentLoader = false;
                  })
                  .catch((error) => {
                      console.log(error);
                      this.initiateFeesPaymentLoader = false;
                      this.showSnackbar("#b71c1c", "Something went wrong");
                  });
                
            },
             sleep(ms) {
              return new Promise((resolve) => setTimeout(resolve, ms));
            },
            async initializeGqErpSDK(referenceNumber, 
            totalFeesDue, gray_clientId, gray_client_secret,
            gray_api_key, online_payment_account_no, org_logo,tenantid,order_id,fee_amount) {
                this.initiateFeesPaymentLoader = true;
                if (!window.GqErpSDK) {
                    await this.sleep(5000); // 5000 milliseconds = 5 seconds
                    console.log("after sleep");
                    await this.initializeGqErpSDK(referenceNumber, totalFeesDue, gray_clientId, gray_client_secret, gray_api_key, online_payment_account_no, org_logo,tenantid,order_id,fee_amount);
                    return;
                }
                console.log("in else");
                window.GqErpSDK.setOptions({
                       env: "staging",
                  //  env: "live",
                    auth: {
                        client_id: gray_clientId,
                        client_secret: gray_client_secret,
                        api_key: gray_api_key,
                    },
                    student_id: this.selected_children.registration_number, //3123026010023
                    customer_mobile: this.selected_children.mobile,
                    reference_id: referenceNumber,
                    student_details: {
                        student_first_name: this.selected_children.fname,
                        student_middle_name: this.selected_children.middlename,
                        student_last_name: this.selected_children.lname,
                    },
                    pp_config: {
                        //  slug: "eduplus-pune",
                        slug: online_payment_account_no,
                    },
                    fee_headers: {
                        total_payable: totalFeesDue,
                    },

                    customizations: {
                        logo_url: org_logo,
                        theme: {
                            theme_color: "#292DC2",
                        },
                    },
                    notes: {
                        learnerdetail: this.selected_children.id,
                        email: this.selected_children.email,
                        tenantid:tenantid,
                        order_id:order_id,
                        fee_amount:fee_amount
                    },
                });
                this.initiateFeesPaymentLoader = false;
                window.GqErpSDK.render();
            },
            loadGQERPSDK(url) {
                const scriptId = "gqerp-jssdk";
                console.log("scriptId::::::::"+scriptId)
                if (document.getElementById(scriptId)) return;
                console.log("after  scriptId::::::::"+scriptId)
                const script = document.createElement("script");
                script.id = scriptId;
                script.async = true;
                script.type = "text/javascript";
                script.src = url;
                console.log("GQERP SDK Loaded!!!!"+url);
                document.getElementsByTagName("head")[0].appendChild(script);
                script.onload = () => {
                    console.log("GQERP SDK Loaded!");
                    if (window.GQERP) {
                        window.GQERP.initialize();
                    }
                };
                script.onerror = () => {
                    console.error("Failed to load GQERP SDK.");
                };
            },

            isVisible(index) {
                if (index === 0) return true
                return this.inst_id.some(
                i => i.id === this.unpaidInstallments[index - 1].id
                )
            },

            onToggle(inst, index) {
                const exists = this.inst_id.some(i => i.id === inst.id)
                    if (!exists) {
                    const allowedIds = this.unpaidInstallments
                        .slice(0, index)
                        .map(i => i.id)

                    this.inst_id = this.inst_id.filter(i =>
                        allowedIds.includes(i.id)
                    )
                }
            },
            payBillDesk(orgid,tenantid,uid,studid,ay,total_amount,inst_id,json_pre_trans_data,hash_val){
                const data={
                    ay:ay,
                    orgid:orgid,
                    studid:studid,
                    uid:uid,
                    fee_amount:total_amount,
                    tenantid:tenantid,
                    hash_val:hash_val,
                    json_pre_trans_data:json_pre_trans_data,
                    purpose:inst_id,
                    payment_type:"INSTALLMENT"
                }
                 this.initiateFeesPaymentLoader = true;
                axios
                  .post("/paymentGatewayBillDesk/initializeBillDeskMACPayment", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                        if (res.data.billdeskhmac) {
                            this.billdeskhmac = true;
                            this.billdeskhmacData = res.data.tempmap;
                        }
                        
                      } else if (res.data.flag == "NO"){
                          this.showSnackbar("#b71c1c", res.data.fsmg);
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong");
                  }).finally(() => {});
            },
            payWithPayU() {
                let formData = new FormData();
                formData.append("orgid", this.pg_hidden.orgid);
                formData.append("tenantid", this.pg_hidden.tenantid);
                formData.append("ay", this.pg_hidden.ay);
                formData.append("uid", this.pg_hidden.uid);
                formData.append("studid", this.pg_hidden.studid);
                formData.append("fee_amount", this.total_amount);
                formData.append("json_pre_trans_data", this.matrix_pg_list);
                formData.append("hash_val", this.pg_hidden.hash_val);
                formData.append("purpose", this.inst_id.name +" Fees");
                 formData.append("payment_type", "INSTALLMENT");

                this.btnloader = true;

                axios.post(this.payuInitiateUrl, formData)
                    .then(res => {
                        if (res.data.flag == "YES") {
                            this.payu_data = res.data.payu_data;
                            this.pu_url = res.data.hidden_fields.locatorURL;
                            this.returnURL = res.data.hidden_fields.returnURL;
                            if (this.pu_url) {
                                this.$nextTick(() => {
                                    this.$refs.payuForm.submit();
                                });
                            }
                        }else{
                            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong")
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.btnloader = false;
                    });
            },

            payWithCCAvenue() {

                let formData = new FormData();
                formData.append("orgid", this.pg_hidden.orgid);
                formData.append("tenantid", this.pg_hidden.tenantid);
                formData.append("ay", this.pg_hidden.ay);
                formData.append("uid", this.pg_hidden.uid);
                formData.append("studid", this.pg_hidden.studid);
                formData.append("fee_amount", this.total_amount);
                formData.append("json_pre_trans_data", this.matrix_pg_list);
                formData.append("hash_val", this.pg_hidden.hash_val);

                // formData.append("orgid", this.pg_hidden.orgid);
                // formData.append("tenantid", this.pg_hidden.tenantid);
                // formData.append("uid", this.pg_hidden.uid);
                // formData.append("fee_amount", this.total_amount);
                // formData.append("studid", this.pg_hidden.studid);
                // formData.append("json_pre_trans_data", this.matrix_pg_list);
                // formData.append("hash_val", this.pg_hidden.hash_val);
                // formData.append("academicyear", this.pg_hidden.ay);
                formData.append("purpose", this.inst_id.name +" Fees");
                 formData.append("payment_type", "INSTALLMENT");

                this.btnloader = true;

                axios.post(this.ccInitiateUrl, formData)
                    .then(res => {
                        if (res.data.flag == "YES") {
                            this.encRequest = res.data.txnToken;
                            this.accessCode = res.data.merchant_key;
                            this.ccUrl = res.data.redirection;
                        if (this.ccUrl && this.encRequest && this.accessCode) {
                            this.$nextTick(() => {
                                document.ccavenueform.submit();
                            });
                        }
                            
                        }else{
                            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong")
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.btnloader = false;
                    });
            },
             ccavenueRedirection(actionurl, token, access_code) {
              var form = document.createElement("form");
              var encRequest = document.createElement("input");
              var access_codes = document.createElement("input");

              form.method = "POST";
              form.id = "nomsemless";
              form.action = actionurl;

              encRequest.value = token;
              encRequest.name = "encRequest";
              encRequest.id = "encRequest";
              encRequest.type = "hidden";
              form.appendChild(encRequest);

              access_codes.value = access_code;
              access_codes.name = "access_code";
              access_codes.id = "access_code";
              access_codes.type = "hidden";
              form.appendChild(access_codes);

              document.body.appendChild(form);
              document.getElementById("nomsemless").style.display = "none";
              form.submit();
            },

            payment(){
               var formData = new FormData(paytmform);
            //    console.log("formData")
            //    console.log(formData)
               this.pg_loader= false
            },
            check(){
                // console.log("Matrix:",this.matrix_list)
                // console.log("matrix_pg_list:",this.matrix_pg_list)
            },
            getstatus(index, name) {
                // if (name != "Remaining") {
                //     if (index != 0) {
                //         this.display_flag = this.installment_list[index - 1].inst_flag;
                //     } else {
                //         this.display_flag = true;
                //     }
                // } else {
                //     this.display_flag = true;
                // }
            },
             showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getmatrix() {
                //alert(this.inst_id)
                const formData = {
                    inst_id: this.inst_id,
                    child: this.selected_children.id,
                    ay: this.selected_ay
                };
                axios
                    .post("/AccountingAndFees/getmatrix_new_multiple", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.matrix_list = res.data.matrix_list;
                            // this.total_outstanding = res.data.total_outstanding;
                            // this.paid_outstanding  = res.data.paid_outstanding;
                            // this.remaining_outstanding = res.data.remaining_outstanding;
                            this.total_amount = res.data.total_amount;
                            this.total_after_discount = res.data.total_after_discount;
                            this.paid_amount = res.data.paid_amount;
                            this.discount_value = res.data.discount_value;
                            this.discount_type = res.data.discount_type;
                            this.fees_amount = res.data.fees_amount;
                            this.debit_card_charges = res.data.debit_card_charges;
                            this.credit_card_charges = res.data.credit_card_charges;
                            this.netbanking_card_charges = res.data.netbanking_card_charges;
                            this.fine = res.data.fine;
                            this.pg_hidden = res.data.pg_hidden
                            this.matrix_pg_list = JSON.stringify(this.pg_hidden.json_pre_trans_data)
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            getDetails() {
            this.inst_id = []
            this.matrix_list = ''
            this.matrix_pg_list = null
            this.total_amount = ''
            this.paid_amount = ''
            this.fees_amount = ''
            this.discount_value = ''
            this.discount_type = ''
            this.total_after_discount = ''
            this.fine = ''
            this.pg_hidden = null
                const formData = {
                    child: this.selected_children.id,
                    ay: this.selected_ay
                };
                this.data_loader = true;
                axios
                    .post("/AccountingAndFees/getPaymentInfo", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            
                            // if(res.data.flag_fee == "YES"){
                                    if(res.data.flag == "YES"){
                                        this.show = true;
                                        this.current_ay = res.data.current_ay;
                                        this.leaner_std = res.data.leaner_std;
                                        this.leaner_div = res.data.leaner_div;
                                        this.installment_list = res.data.installment_list;
                                        this.installment_details_list = res.data.installment_details_list
                                        this.outstanding_details_list = res.data.outstanding_details_list
                                        this.outstanding = res.data.outstanding
                                        for (var i = 0; i < this.installment_details_list.length; i++) {
                                            if (this.installment_details_list[i].balnace_fee == 0) {
                                                var details_id = this.installment_details_list[i].id;
                                                for (var j = 0; j < this.installment_list.length; j++) {
                                                    if (this.installment_list[j].id === details_id) {
                                                        // Remove the matching object from installment_list
                                                        this.installment_list.splice(j, 1);
                                                        break; // Exit the loop after removing the matching object
                                                    }
                                                }
                                            }
                                        }
                                        // var remaining = { id: "null", name: "Remaining" };
                                        // this.installment_list.push(remaining);


                                        //added 18-04-22
                                        this.learner_info = res.data.learner_info
                                        this.ay_header = res.data.ay_header 
                                        this.all_total_amount = res.data.all_total_amount
                                        this.all_total_paid = res.data.all_total_paid
                                        this.all_total_remaining = res.data.all_total_remaining
                                        //13mar2023 vikas
                                        this.pgs = res.data.pgs
                                        this.data_loader = false;
                                    }
                                    else  if(res.data.flag == "NO"){
                                        this.showSnackbar("#b71c1c", res.data.snackbar);
                                        this.data_loader = false;
                                    }
                            // }
                            //  else  if(res.data.flag_fee == "NO"){
                            //      this.showSnackbar("#b71c1c", "Fee Structure Not Added!!!");
                            //  }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.data_loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                        this.data_loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            let org_id = localStorage.getItem("EPS-tenant");
            this.history = "https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/payment_history.jpeg"
            if(org_id == "zeal"){
                this.path  = null            
            }
            else if(org_id == "sbpps"){
                this.path = "https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/Documents/S.B.P.P.S+Cancellation+Policy+++2021-22.pdf"
            }
            else if(org_id == "wws"){
                this.path = "https://wws-schoolerp.s3.ap-south-1.amazonaws.com/documents/wws_payment_policies.pdf"
            }
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                            this.academic_year_list = res.data.academicyearlist
                            this.selected_ay = res.data.current_ay;
                            this.selected_children = this.children[0];
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
    };
</script>

<style scoped>
    /* table {
        border-collapse: collapse;
        font-size: 12px;
        border: 2px solid #cccccc;
        background-color: #ffffff;
    }
    th {
        border: 2px solid #cccccc;
        padding: 4px;
    }
    td:nth-child(odd) {
        width: 15em;
        padding: 4px;
        text-align: center;
        border: 2px solid #cccccc;
    }
    td:nth-child(even) {
        width: 15em;
        padding: 4px;
        text-align: center;
        border: 2px solid #cccccc;
    } */
    td,
    th {
        border: 1px solid #ccc;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
     .scroll {
        overflow-x: scroll;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .noborder {
        border: none;
    }
    .noborder:hover {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
    }
    .text-color {
        font-weight: bold;
        color: red;
    }
    .text-color2 {
        font-weight: bold;
        color: darkseagreen;
    }
    .text-color1 {
        font-weight: bold;
        color: darkblue;
    }
    .text-color3 {
        font-weight: bold;
        color: #26C6DA;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-grad {
        /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
    }
    .btn-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: black;
        box-shadow: 0 0 20px rgb(190, 187, 187);
        border-radius: 10px;
        display: block;
    }

    .btn-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: black;
        text-decoration: none;
    }
    .btn1-grad {
        background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
    }
    .btn1-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
        border-radius: 10px;
        display: block;
    }

    .btn1-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
    }
    .radio-row {
        gap: 20px;          /* space between radios */
    }

    .radio-item {
        display: flex;
        align-items: center;
        white-space: nowrap;
    }

    .radiospace {
        margin-right: 6px;
    }
    .fee-summary-row {
        margin: 12px 0px;
        gap:70px;
    }

.fee-item {
  text-align: center;
  font-weight: 600;
  /* min-width: 120px; */
}

.fee-item span {
  /* display: block; */
  margin-top: 4px;
  font-size: 16px;
}

.fee-item.total {
  color: #1e3a8a; 
}

.fee-item.discount {
  color: #0891b2;
}

.fee-item.paid {
  color: #15803d; 
}

.fee-item.fine {
  color: #dc2626;
}

.fee-item.remaining {
  color: #b45309; 
}

.button:hover{
    color: white !important;
}

    .span-mr {
        margin: 1rem !important;
        padding: 0px;
    }
.flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
